import { LoadingButton as MuiLoadingButton } from '@mui/lab'
import { Button as MuiButton, DialogActions as MuiDialogActions } from '@mui/material'

interface Props {
  disabled: boolean
  onClose: () => void
}

export default function DialogActionButtons({ disabled, onClose }: Props) {
  return (
    <MuiDialogActions>
      <MuiButton color='inherit' disabled={disabled} onClick={onClose} variant='text'>
        CANCEL
      </MuiButton>

      <MuiLoadingButton loading={disabled} type='submit' variant='contained'>
        SAVE
      </MuiLoadingButton>
    </MuiDialogActions>
  )
}
